import PropTypes from 'prop-types'
import React, { Component } from 'react'

import { inject, observer } from 'mobx-react'
import BasePage from '../../base/components/BasePage'
import Loader from '../../shared/components/Loader'

@inject('user')
@observer
export default class RootContainer extends Component {

  static propTypes = {
    children: PropTypes.oneOfType([
      PropTypes.arrayOf(PropTypes.node),
      PropTypes.node,
    ]),
    user: PropTypes.object.isRequired,
  }

  componentWillMount() {
    const { user } = this.props
    if (!user.length && !user.collection.length) {
      this.props.user.load()
    }
  }

  render() {

    const children = this.props.user.loading
      ? <Loader>Nutzerdaten werden geladen...</Loader>
      : this.props.children

    return (
      <BasePage type="user">
        {children}
      </BasePage>
    )
  }
}



// WEBPACK FOOTER //
// ./src/user/containers/Root.js